import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LOCALE, LOCALE_STORAGE_KEY, SUPPORTED_LOCALES } from './config';
import { defaultNS, NS, resources } from './resources';

void i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    ns: NS,
    defaultNS,
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: SUPPORTED_LOCALES,
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    interpolation: { escapeValue: false },
    returnNull: false,
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: LOCALE_STORAGE_KEY,
      caches: ['localStorage'],
    },
    react: { useSuspense: false },
    debug: import.meta.env.DEV,
    saveMissing: import.meta.env.DEV,
    missingKeyHandler: import.meta.env.DEV
      ? (lngs: readonly string[], ns: string, key: string) => {
          console.warn(`[i18n] missing key: ${lngs.join(',')}:${ns}:${key}`);
        }
      : false,
  });

i18next.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

export default i18next;
